export default {
    index:{
        helpTitle:'帮助',
        helpTips0:'5种按键模式介绍:',
        helpTips1:'1.普通键:将3键键盘某一按键按键定义为如1、2、3、a、b、c、?、空格等可输入的普通按键',
        helpTips1_1:'注意:普通键如果输入大写字母或!@#$%等按键 实际是通过Shift+对应按键触发!',
        helpTips2:'2.功能键:将3键键盘某一按键按键定义为Ctrl、Alt、Win、Command、回车等功能按键',
        helpTips2_1:'F13-F24为特殊功能按键,普通键盘并没有,可以作为软件内的自定义快捷键,防冲突使用!',
        helpTips3:'3.多媒体键:将3键键盘某一按键按键定义为音量加、亮度加、打开浏览器等多媒体按键',
        helpTips4:'4.组合键:将3键键盘某一按键按键定义为2键-5键组合,如一键Ctrl+c、一键Win+l、一键Ctrl+Alt+Delete等组合按键',
        helpTips5:'5.字符串:将3键键盘某一按键按键定义为输入字符串,如一键输入用户名、一键输入select * from等',
        helpTips6:'6.鼠标:将3键键盘某一按键按键定义为鼠标按键点击、鼠标移动、滚轮滑动等',
        helpTips7:'7.如果插上电脑不识别，用酒精喷下插口引脚然后刷一刷，晾干再试试看',
        helpTips8:'8.用的是国产青轴，轴和键帽都可以热插拔，不喜欢可以自己换掉',
        helpButton:'查看帮助',
        connButtonText1:'连接3 Key键盘',
        keyAllLabel:'3键同时按下时,作为独立按键',
        keyAllTrue:'开',
        keyAllFalse:'关',
        changeLog5:'2024.11.2 软件更新为threekey_v7.0.hex 新增长按时按住鼠标设置',
        changeLog4:'2024.7.12 软件更新为threekey_v6.0.hex 新增输入字符串后回车换行设置',
        changeLog3:'2023.6.16 软件更新为threekey_v5.1.hex 修复key2字符串模式记忆bug 修复三键按下部分设置不能记忆',
        changeLog1:'2023.5.4 软件更新为threekey_v5.0.hex 新增设置为鼠标功能',
        changeLog1_1:'如何更新',
        changeLog2:'2023.4.25 软件更新为threekey_v4.1.hex 修复了windows在刚连接键盘就立刻按键的情形 按键失效问题',
        changeLog2_1:'如何更新',
        videoText:'视频介绍',
        keyTest:'在线键盘测试网站',
        mouseTest:'在线鼠标测试网站',
        openSource:'项目软硬件全部开源',
        backToIndex:'原作者的主页：topyuan.top',
        submit:'提交',
        browserErr:'请使用103以上版本Chrome或Edge浏览器,https方式访问此页面!',
        firmwareErr:'当前连接的3键键盘不是最新固件,不支持鼠标设置,请更新!!<br/><br/>新版本:<br/>5.0 新增鼠标设置功能<br/>4.1 修复bug<br/>4.0 新增最多5键的组合键 三键同时按下设置<br/>',
        firmwareErrv5:'当前连接的3键键盘不是最新固件,不支持输入字符串后加回车换行,请更新!!<br/><br/>新版本:<br/>6.0 新增输入字符串后回车换行设置<br/>',
        firmwareErrv6:'当前连接的3键键盘不是最新固件,不支持长按时按住鼠标,请更新!!<br/><br/>新版本:<br/>7.0 新增长按时按住鼠标设置<br/>',
        tip:'提示',
        updateHelp:'更新教程',
        updateNo:'暂不更新,返回',
        redirecting:'正在跳转....请稍后',
        connFirst:'请先连接键盘',
        disconnect:'断开连接',
        success:'设置成功!',
        firmwareErr1:'当前连接的3键键盘不是最新固件,请更新!!<br/><br/>新版本:<br/>5.0 新增鼠标设置功能<br/>4.1 修复bug<br/>4.0 新增最多5键的组合键 三键同时按下设置<br/>',
        updateNo1:'暂不更新,先改键(跳转到旧版改键页)',
        conError1:'端口已占用,连接失败!',
        conError2:'连接失败,原因:',
        conError3:'断开连接失败!请刷新页面!',
        howtoaddress:'https://topyuan.top/3key/howtoupdate',
    },
    keyConfig:{
        keyDes1:'普通键',
        keyDes2:'功能键',
        keyDes3:'多媒体键',
        keyDes4:'组合键',
        keyDes5:'字符串',
        keyDes6:'鼠标',
        select:'请选择',
        mix1:'增加功能键',
        mix2:'增加普通键',
        mix3:'删除组合键',
        mix4:'重置组合键',
        mix5:'常用组合键',
        mixtip:'以下为常见组合键,可快速设置,不知道设成啥可以看看,不定期更新',
        mixcommon1:'组合键',
        mixcommon2:'描述',
        mixcommon3:'操作',
        set:'设置',
        inputErr:'输入错误',
        selectErr:'选择错误',
        mixErr:'组合键至少为2键组合!',
        mixErr1:'组合键第',
        mixErr2:'位选择错误',
        mixErr3:'位输入错误',
        textErr:'字符串不能为空',
        textErr1:'字符串输入错误，无此键位',
        setErr:'设置错误',
        delErr:'已无法再删除!',
        mixMaxErr:'最多支持5个按键组合!',
        mixAdd:'请增加功能键或普通键',
        mixMax5:'以上所有按键组合,最多支持5键',
        holdTip:'长按时连续触发',
        holdPressTip:'长按时按住鼠标',
        stringEnter:'输入后按Enter换行',
        move:'移动距离',
        strong:'力度',
        mouses:['左键点击','中键点击','右键点击','随机移动位置','向上移动','向下移动','向左移动','向右移动','向上滚轮','向下滚轮'],
        functionkeys:["左Ctrl", "左Shift", "左Alt", "左Win/Command", "右Ctrl", "右Shift", "右Alt", "右Win/Command", "向上", "向下", "向左", "向右", "Backspace", "Tab", "回车Enter", "ESC", "Insert", "Delete", "Page Up", "Page Down", "Home", "End", "Caps Lock", "Print Screen", "Scroll Lock", "Pause Break", "Num Lock", "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12", "F13", "F14", "F15", "F16", "F17", "F18", "F19", "F20", "F21", "F22", "F23", "F24", "Menu", "/(小键盘)", "*(小键盘)", "-(小键盘)", "+(小键盘)", "Enter(小键盘)", "1(小键盘)", "2(小键盘)", "3(小键盘)", "4(小键盘)", "5(小键盘)", "6(小键盘)", "7(小键盘)", "8(小键盘)", "9(小键盘)", "0(小键盘)", ".(小键盘)"],
        mediakeys:["电源键", "睡眠键", "录制", "快进", "回放", "下一首", "上一首", "停止播放", "播放/暂停", "暂停", "静音", "音量增加", "音量减少","屏幕亮度增加","屏幕亮度减少","屏保","打开音乐软件","打开Email软件","打开计算器","打开文件管理器","打开浏览器","浏览器后退","浏览器前进","浏览器刷新","浏览器书签"]
    }
}



// WEBPACK FOOTER //
// ./src/i18n/zh.js